"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class ProgramService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'programs';
        this.getPrograms = async (ou, personId, pageNumber, pageSize) => {
            const queryString = this.objectToQueryString({ page_no: pageNumber, page_size: pageSize, person_id: personId });
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/catalog/${ou}/${this.RESOURCE}?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProgramsCarousel = async (ou, personId, level) => {
            const queryString = this.objectToQueryString({ person_id: personId, level: level });
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/catalog/${ou}/${this.RESOURCE}?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProgramById = async (id, params) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const objectToQueryString = (obj) => {
                return Object.keys(obj).map(key => `${key}=${obj[key]}`).join("&");
            };
            const path = params ? `${URL}?${objectToQueryString(params)}` : URL;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProgramFeePlans = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}/fee-plans`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProgramsNumberByOU = async (ou, level_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/count/${ou}?level_id=${level_id === undefined ? '' : level_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getFAQList = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/faq`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getFAQListByProgram = async (level_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/faq/${level_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        this.getProgramCoursesByPersonIdAndProgramId = async (person_id, program_id, student = false, student_id = '') => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/${this.RESOURCE}/${program_id}/courses?student=${student}&student_id=${student_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProgramsInProgressByUser = async (person_id, student_id = '') => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/${this.RESOURCE}/in_progress?student_id=${student_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postPersonEnrollToClass = async (person_id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/users/${person_id}/courses/enrollment`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.ProgramService = ProgramService;
